import {
  formatToImageArgs,
  formatToJsonArgs,
  formatToPkArgs,
} from '../../utils/api';
import { authApiCall } from '../auth/saga';

export const getInfo = () =>
  authApiCall({
    url: '/users/business-info/',
    method: 'get',
  });

/**
 * Account form data field names that should be
 * formatted specifically before sending.
 */
export const FORMATTING_FIELDS = {
  LOCATION: 'location',
  LOGO: 'logo',
  COVER_IMAGE: 'cover_image',
  PROVINCE: 'province',
  CITY: 'city',
  ADDITIONAL_CITIES: 'additional_cities',
  CATEGORIES: 'categories',
  SUBCATEGORIES: 'subcategories',
  SOCIALS: 'socials',
  HOURS: 'hours',
};

export const formatToAccountFormData = values => {
  const data = new FormData();

  const {
    LOCATION,
    LOGO,
    COVER_IMAGE,
    PROVINCE,
    CITY,
    ADDITIONAL_CITIES,
    CATEGORIES,
    SUBCATEGORIES,
    SOCIALS,
    HOURS,
  } = FORMATTING_FIELDS;

  for (const key of Object.keys(values)) {
    switch (key) {
      case LOCATION:
      case SOCIALS:
      case HOURS:
        data.append(...formatToJsonArgs(key, values[key]));
        break;

      case LOGO:
      case COVER_IMAGE:
        data.append(...formatToImageArgs(key, values[key]));
        break;

      case PROVINCE:
        /**
         * Province does not need to be included in the request.
         * City already contains its province relationship.
         */
        break;

      case CITY:
        data.append(...formatToPkArgs(key, values[key]));
        break;
      case ADDITIONAL_CITIES:
        if (Array.isArray(values[key])) {
          for (const city of values[key]) {
            data.append(...formatToPkArgs(key, city));
          }
        }
        break;

      case CATEGORIES:
      case SUBCATEGORIES:
        if (Array.isArray(values[key])) {
          for (const item of values[key]) {
            data.append(...formatToPkArgs(key, item));
          }
        }
        break;
      default:
        data.append(key, values[key]);
    }
  }

  return data;
};

export const updateInfo = updatedValues => {
  const data = formatToAccountFormData(updatedValues);

  return authApiCall({
    url: '/users/update-business-info/',
    method: 'patch',
    data,
    headers: {
      'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
      Accept: 'application/json',
    },
  });
};